import { Translator } from 'Translator';
import classnames from 'classnames';
import React from 'react';

import CSS from './ExperienceCardAvatarLabel.module.scss';

interface ExperienceCardAvatarLabelProps {
  animate: boolean;
  nrOfHosts: number;
  text?: string;
}

function ExperienceCardAvatarLabel({
  animate,
  nrOfHosts,
  text,
}: ExperienceCardAvatarLabelProps) {
  const classes = classnames(CSS.experienceCardAvatarLabel, {
    [CSS.experienceCardAvatarLabelAnimate]: animate,
  });

  return (
    <span className={classes}>
      {!!text
        ? text
        : Translator.translate(
            'ExperienceCard.Details.hostsAvailable',
            { nrOfHosts },
            true,
            '{nrOfHosts} hosts available',
          )}
    </span>
  );
}

export default ExperienceCardAvatarLabel;
